// src/pages/index.tsx
import { useEffect } from 'react';

import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { PAGENAME } from '@/common/common.contants';
import SearchStartPage from '@/mainPages/search-start';
import { DefaultLocale } from '@/types/locale.types';

const PLPPage = dynamic(() => import('../mainPages/plp'), {
  ssr: false,
});

export default function HomePage() {
  const router = useRouter();
  const { asPath, isReady, query } = router;

  useEffect(() => {
    if (!isReady) return;
    const lang = typeof query.lang === 'string' ? query.lang : DefaultLocale;
    void router.prefetch(`/${lang}/${PAGENAME.PLP_PAGE}`);
  }, [isReady, query.lang, router]);

  if (new RegExp(`/${PAGENAME.PLP_PAGE}(/|\\?|&|$)`).test(asPath)) {
    return <PLPPage />;
  } else {
    return <SearchStartPage />;
  }
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
